"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ThemeProviderContext", {
  enumerable: true,
  get: function () {
    return _reactUiTheming.ThemeProviderContext;
  }
});
exports.default = _default;
var _reactUiTheming = require("@concur/react-ui-theming");
var _react = require("react");
/* eslint-disable func-names */
function _default() {
  const themeProviderContext = (0, _react.useContext)(_reactUiTheming.ThemeProviderContext);
  const {
    theme = 'sap_horizon'
  } = themeProviderContext || {};
  return theme.indexOf('_hcw') >= 0 || theme.indexOf('_hcb') >= 0;
}